import axios from 'axios';
import { distance } from '@turf/turf';

function getNearbyFietssnelweg(point, fietssnelwegen) {
  if (!point || !fietssnelwegen) {
    return undefined;
  }

  let closestFietssnelweg;
  let minDistance = Number.MAX_SAFE_INTEGER;

  for (let i = 0; i < fietssnelwegen.length; i += 1) {
    const fietssnelweg = fietssnelwegen[i];

    if (fietssnelweg.properties.BEFIETSBAAR) {
      for (let j = 0; j < fietssnelweg.geometry.coordinates.length; j += 1) {
        const coordinates = fietssnelweg.geometry.coordinates[j];

        for (let k = 0; k < coordinates.length; k += 1) {
          const coordinate = coordinates[k];
          const distanceToPoint = distance([point.lng, point.lat], coordinate, { units: 'meters' });

          if (distanceToPoint < minDistance) {
            minDistance = distanceToPoint;
            closestFietssnelweg = fietssnelweg;
          }
        }
      }
    }
  }

  return {
    closestFietssnelweg,
    distanceToFietssnelweg: minDistance,
  };
}

async function getFietssnelwegen() {
  const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/api/fietssnelwegen`);

  return data;
}

export {
  getNearbyFietssnelweg,
  getFietssnelwegen,
};